<template>
  <v-theme-provider dark>
    <section id="about-image-a">
      <base-img
        :height="$vuetify.breakpoint.mdAndUp ? 250 : 225"
        :gradient="gradient"
        :src="require('@/assets/home-hero.jpg')"
        flat
        max-width="100%"
      >
        <v-row
          align="center"
          class="ma-0 fill-height text-center"
          justify="center"
        >
          <v-col cols="12">
            <base-heading title="복잡하고 어려운 FM 설비관리를 쉽고 편하게!<br>스마트폰 터치만으로 입력을 완료하세요." />

            <div class="white--text">
              아직도 여러 사람의 손이 닿는 파일철이나 공용 문서함을 사용하시나요?<br>
              손으로 직접 입력한 설비의 점검일지들은 캐비닛에서 생을 마감합니다.<br>
              디지털화의 2중 작업 없이 한번에 CLOUD 데이터를 생성하세요.
            </div>
          </v-col>
        </v-row>
      </base-img>
    </section>
  </v-theme-provider>
</template>

<script>
  // Components
  import {
    HexToRGBA,
    RGBAtoCSS,
  } from 'vuetify/lib/util/colorUtils'

  export default {
    name: 'AboutImage',

    provide: {
      heading: { align: 'center' },
    },

    computed: {
      gradient () {
        const color = `${this.$vuetify.theme.themes.light.secondary}CC`
        const overlay = RGBAtoCSS(HexToRGBA(color))

        return `to top, ${overlay}, ${overlay}`
      },
    },
  }
</script>

<style lang="sass">
  #hero-alt
    .v-breadcrumbs__item
      color: #FFFFFF
</style>
